import React from "react";

import PaymentLayout from "./payment_layout";

const PaymentPage = () => {
  return (
    <>
      <PaymentLayout />
    </>
  );
};
  
export default PaymentPage;